import React, { useContext, useMemo } from "react";
import {
  headerBar, content, img, urlBox, hiddenBestsellers
  , cartContainer, cartIcon, cartCount
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import Link from "components/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import { useMediaQuery } from "react-responsive";
import GlobalContext from "services/global-context";
import { useLocation } from "@reach/router";
import CartIcon from "assets/svgs/cart-icon.svg";

const HeaderBar = ({ data }) => {
  if (!data.show) return <></>;

  const globalContenxt = useContext(GlobalContext);
  const bestSellerCollection = globalContenxt?.handle?.includes("collections/bestseller-special");
  const location = useLocation();

  const wrapperStyle = {};
  if (data.txtColor && data.txtColor.hex) wrapperStyle.color = data.txtColor.hex;
  if (data.bgColor && data.bgColor.hex) wrapperStyle.backgroundColor = data.bgColor.hex;

  const { textAndIcons } = data;
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isFoodBoom = location.pathname.includes("foodboom");
  const filteredTextAndIcons = useMemo(() => {
    if (location.pathname.includes("foodboom")) {
      return textAndIcons?.filter(item => !item?.text?.includes("Fachberatung"));
    }
    return textAndIcons;
  }, [location.pathname, textAndIcons]);

  let cartTotalQty;

  if (typeof window === "undefined")
    cartTotalQty = 0;
  else
    cartTotalQty = localStorage.getItem("cartTotalQty") || 0;

  var settings = {
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    modules: [Autoplay, Pagination],
    pagination: { clickable: true },
    navigation: { clickable: true },
    effect: "fade",
    fadeEffect: { crossFade: true },
  };

  return (
    <div className={`${headerBar} ${bestSellerCollection && hiddenBestsellers}`} style={wrapperStyle}>
      {isMobile ? <Swiper {...settings}>
        {textAndIcons?.map((item, i) => (
          <SwiperSlide key={i}>
            <span className={content}>
              <Link to={item?.link} className={urlBox}>
                <img className={img} src={getImagePath(item?.icon)} alt={item?.icon?.alt} />
                <span>{item?.text}</span>
              </Link>
            </span>

          </SwiperSlide>
        ))}

      </Swiper> :
        <>
          {filteredTextAndIcons?.map((item, i) => (
            <span className={content} key={i}>
              <Link to={item?.link} className={urlBox}>
                <img className={img} src={getImagePath(item?.icon)} alt={item?.icon?.alt} />
                <span>{item?.text}</span>
              </Link>
            </span>
          ))}
        </>}
      {isFoodBoom &&
        <div className={cartContainer} onClick={globalContenxt?.toggleCart}>
          <div className={cartIcon}><CartIcon /></div>
          {cartTotalQty !== null && parseInt(cartTotalQty) !== 0 && <div className={cartCount}>{cartTotalQty}</div>}
        </div>
      }
    </div>
  );
};

export default HeaderBar;
